import { useState } from 'react'

import BookTutorPaymentModal from './BookTutorPaymentModal'
import BookTutorSuccessModal from './BookTutorSuccessModal'

const BookTutor = ({ open, data, onClose, onHide }) => {
  const [successData, setSuccessData] = useState(false)
  const [isSuccessOpen, setIsSuccessOpen] = useState(false)

  const handleOpenSuccessModal = (data) => {
    onHide()

    setTimeout(() => {
      setIsSuccessOpen(true)
      setSuccessData(data)
    })
  }

  const handleCloseSuccessModal = () => {
    setIsSuccessOpen(false)

    setTimeout(() => {
      setSuccessData(null)
    }, 300)
  }

  return (
    <>
      <BookTutorPaymentModal
        open={open}
        data={data}
        onClose={onClose}
        onSuccess={handleOpenSuccessModal}
      />

      <BookTutorSuccessModal
        open={isSuccessOpen}
        classBanner={successData}
        onClose={handleCloseSuccessModal}
      />
    </>
  )
}

export default BookTutor
